import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'

/**
 * Central GSAP setup. All animations in the site are pure GSAP recreations of
 * the original Webflow IX2 interactions. Plugins are registered once on the
 * client. Webflow's named easings are recreated as CustomEase curves so the
 * motion matches the original timing exactly.
 *
 * Webflow easing -> cubic-bezier:
 *   "ease"      -> 0.25, 0.1, 0.25, 1   (CSS ease)
 *   "easeIn"    -> 0.42, 0, 1, 1
 *   "easeOut"   -> 0, 0, 0.58, 1
 *   "easeInOut" -> 0.42, 0, 0.58, 1
 */
let registered = false

export const registerGsap = (): void => {
    if (registered || typeof window === 'undefined') return

    gsap.registerPlugin(useGSAP, ScrollTrigger, CustomEase)

    CustomEase.create('wf-ease', '0.25, 0.1, 0.25, 1')
    CustomEase.create('wf-ease-in', '0.42, 0, 1, 1')
    CustomEase.create('wf-ease-out', '0, 0, 0.58, 1')
    CustomEase.create('wf-ease-in-out', '0.42, 0, 0.58, 1')

    registered = true
}

// Map a Webflow easing name to its registered GSAP ease.
export const wfEase = (easing?: string): string => {
    switch (easing) {
        case 'ease':
            return 'wf-ease'
        case 'easeIn':
            return 'wf-ease-in'
        case 'easeOut':
            return 'wf-ease-out'
        case 'easeInOut':
            return 'wf-ease-in-out'
        default:
            return 'none'
    }
}

// Webflow durations/delays are authored in milliseconds.
export const ms = (value: number): number => value / 1000

export { gsap, useGSAP, ScrollTrigger, CustomEase }
